export default {
      id: "profile-patient_full-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#profile-patient_full",
      toString: function () {
        return this.url;
      }
    }